import styled, {keyframes} from 'styled-components/macro';
import { useEffect, useState } from "react";

import {CSS_PADDING,CSS_SELECTOR_RADIUS} from '../constants';

// import big_rotatecursor from '../assets/big_rotatecursor.svg';
// const rotatecursor_animation = keyframes`
// 0% { 	transform: 	translateX(-30px) 	rotate(-90deg); }
// 50% { 	transform: 	translateX(30px) 	rotate(90deg); }
// 100% { 	transform: 	translateX(-30px) 	rotate(-90deg); }
// `
const pop_in_animation = keyframes`
0% {
opacity: 0;
transform: scale3d(0.3, 0.3, 0.3);
}
20% {
transform: scale3d(1.1, 1.1, 1.1);
}
40% {
transform: scale3d(0.9, 0.9, 0.9);
}
60% {
opacity: 1;
transform: scale3d(1.03, 1.03, 1.03);
}
80% {
transform: scale3d(0.97, 0.97, 0.97);
}
to {
opacity: 1;
transform: scale3d(1, 1, 1);
}
`

const InvitationStyled = styled.div`
	padding: ${CSS_PADDING} ${CSS_PADDING} 0;
	display: flex;
	flex-direction: column;
	justify-content:center;
	align-items:center;
	position: absolute;
	overflow:hidden;
	top:0;
	right:0;
	left:0;
	bottom: 70px;

	&,*{
		user-select: none;
		touch-callout: none;
		pointer-events: none;
	}
	.infos {
		padding: 7px 10px;
		line-height: 16px;
		font-size: 14px;
		display: inline-block;

		background: rgba(0, 0, 0, 0.8);
		border-radius: ${CSS_SELECTOR_RADIUS};
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
		backdrop-filter: blur(3px);
		-webkit-backdrop-filter: blur(3px);
		border: 1px solid #000;

		color:#fff;
		text-align:center;
		transition: opacity 0.2s;

		animation-fill-mode: both;
		animation-duration: 1s;
		animation-iteration-count: 1;
	}
	i {
		white-space:nowrap;
	}

	&.show {
		.infos {
			opacity:1;
			animation-name: ${pop_in_animation};
		}
	}
	& {
		.infos {
			opacity:0;
		}
	}
`;
// .icon {
// 	width:32px;
// 	height:32px;
// 	background-repeat: no-repeat;
// 	background-position: 50% 50%;
// 	background-image: url(${big_rotatecursor});
// 	animation-name: ${rotatecursor_animation};
// 	animation-duration: 2s;
// 	animation-iteration-count: infinite;
// }

function Invitation({
	show = true,
	delay = 10
}){
	const [shown,setShown] = useState(false);
	// Downloads crash on iOS 16 (iPhone 8)
	// even with only 1 image
	// even on low resolution
	const touchable = (navigator.maxTouchPoints > 0);

	useEffect(()=>{
		let timeout_id;
		if(show){
			timeout_id = setTimeout(()=>{
				setShown(true);
			},delay);
		}else{
			setShown(false);
		}
		return ()=>{
			if(timeout_id){
				clearTimeout(timeout_id);
			}
		}
	},[show,delay]);
	return (
		<InvitationStyled className={shown?'show':'hide'}>
			<div className="infos">
				{touchable?"Touchez l'abri pour le tourner":<>Pour tourner l'abri, cliquez dessus <i>puis bougez votre souris</i></>}
			</div>
		</InvitationStyled>
	);
}

export default Invitation;
